import { render } from "./BannerSSK.vue?vue&type=template&id=025b5574&scoped=true"
import script from "./BannerSSK.vue?vue&type=script&lang=js"
export * from "./BannerSSK.vue?vue&type=script&lang=js"

import "./BannerSSK.vue?vue&type=style&index=0&id=025b5574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025b5574"]])

export default __exports__